import { WEATHER_AGENT } from '@fruitful/llm-service-shared';
import { Redirect, router } from 'expo-router';

import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import { MastraChat } from '../../llm-service/components/MastraChat';
import { MastraChatShell } from '../../llm-service/components/shared-chat/MastraChatShell';
import { useUser } from '../../user/providers/UserProvider';

const WeatherAgentPage = () => {
    const { user } = useUser();
    const greeting = user?.firstName == null ? 'Hi' : `Hi ${user.firstName}`;

    if (IS_PRODUCTION) {
        return <Redirect href="/" />;
    }

    const handleClose = () => {
        if (router.canGoBack()) {
            router.back();
        } else {
            router.navigate('/dev');
        }
    };

    return (
        <MastraChatShell onClose={handleClose}>
            <MastraChat
                agent={WEATHER_AGENT}
                greeting={greeting}
                introCopy={[
                    'Ask me about the weather in any city. I will look up current conditions and help you plan around them.',
                ]}
                placeholder="Ask about the weather..."
            />
        </MastraChatShell>
    );
};

export default WeatherAgentPage;
